<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">

    <section class="border border-gray-800 p-3">
        <div class="flex justify-between">
            <h4 class="text-white text-sm font-bold uppercase mb-3">Create feature</h4>
            <button type="button" class="close" @click.prevent="closeModal">
              <span>&times;</span>
            </button>
        </div>
    </section>
    <section class="border border-gray-800 p-3">
        <div class="grid grid-cols-3 sm:grid-cols-6 gap-3">
            <FeatureBox title="Audioguide" featureClass="ricon-headphone"
            :clickFunc="() => showCreateOneFeatureModal('audioguide')" />

            <FeatureBox title="Augmented reality" featureClass="ricon-augmented-reality-weiss"
            :clickFunc="() => showCreateOneFeatureModal('augmented_reality')" />

            <FeatureBox title="Panorama" featureClass="ricon-room360"
            :clickFunc="() => showCreateOneFeatureModal('panorama')" />

            <FeatureBox title="Text" featureClass="ricon-bubble"
            :clickFunc="() => showCreateOneFeatureModal('text')" />

            <FeatureBox title="Video" featureClass="ricon-video"
            :clickFunc="() => showCreateOneFeatureModal('video')" />

            <FeatureBox v-if="showMapFeature()" title="Map" featureClass="ricon-location"
            :clickFunc="() => showCreateOneFeatureModal('map')" />

        </div>
    </section>

    </div>
  </div>
</div>
<!-- Another modal -->
<CreatePanoramaFeatureModal :form="feature_panorama_form" :showModal="showPanoramaFeatureModal" :closeModal="closeCreateOneFeatureModal" :changeUploadBoxState="changeUploadBoxState"
:featureName="featureName" :file_types="file_types" />
<!-- Another modal -->
<CreateVideoFeatureModal :form="feature_video_form" :showModal="showVideoFeatureModal" :closeModal="closeCreateOneFeatureModal"
:featureName="featureName" :changeUploadBoxState="changeUploadBoxState"/>
<!-- Another modal -->
<CreateAudioFeatureModal :form="feature_audioguide_form" :showModal="showAudioFeatureModal" :closeModal="closeCreateOneFeatureModal"
:featureName="featureName" :changeUploadBoxState="changeUploadBoxState"/>
<!-- Another modal -->
<CreateTextFeatureModal :form="feature_text_form" :showModal="showTextFeatureModal" :closeModal="closeCreateOneFeatureModal"
:featureName="featureName" :changeUploadBoxState="changeUploadBoxState"/>
<!-- Another modal -->
<CreateAugmentedRealityFeatureModal :form="feature_augmented_reality_form" :showModal="showAugmentedRealityModal" :closeModal="closeCreateOneFeatureModal"
:featureName="featureName" :changeUploadBoxState="changeUploadBoxState"/>
<!-- Another modal -->
<CreateMapFeatureModal :form="feature_map_form" :showModal="showMapFeatureModal" :closeModal="closeCreateOneFeatureModal"
:featureName="featureName" :changeUploadBoxState="changeUploadBoxState"/>
</template>

<script>
import FeatureBox from '@/Pages/Station/Partials/Features/FeatureBox'
import CreatePanoramaFeatureModal from '@/Pages/Station/Partials/Features/Panorama/CreatePanoramaFeatureModal'
import CreateVideoFeatureModal from '@/Pages/Station/Partials/Features/Video/CreateVideoFeatureModal'
import CreateAudioFeatureModal from '@/Pages/Station/Partials/Features/AudioGuide/CreateAudioFeatureModal'
import CreateTextFeatureModal from '@/Pages/Station/Partials/Features/Text/CreateTextFeatureModal'
import CreateAugmentedRealityFeatureModal from '@/Pages/Station/Partials/Features/AugmentedReality/CreateAugmentedRealityFeatureModal'
import CreateMapFeatureModal from '@/Pages/Station/Partials/Features/Map/CreateMapFeatureModal'

export default {
    components: {
        FeatureBox,
        CreatePanoramaFeatureModal,
        CreateVideoFeatureModal,
        CreateAudioFeatureModal,
        CreateTextFeatureModal,
        CreateAugmentedRealityFeatureModal,
        CreateMapFeatureModal,
    },
    props: ['showModal',
            'closeModal',
            'changeUploadBoxState',
            'feature_panorama_form',
            'feature_audioguide_form',
            'feature_video_form',
            'feature_text_form',
            'feature_augmented_reality_form',
            'feature_map_form',
            ],
    data(){
        return{
            showPanoramaFeatureModal: false,
            showVideoFeatureModal: false,
            showAudioFeatureModal: false,
            showTextFeatureModal: false,
            showAugmentedRealityModal: false,
            showMapFeatureModal: false,
            featureName: '',
            file_types: []
        }
    },
    methods: {
        showCreateOneFeatureModal(featureType){
            if( !['panorama', 'video', 'audioguide', 'text', 'augmented_reality', 'map'].includes(featureType) ){
                return;
            }
            this.closeModal();
            this.featureName = this.getFeatureName(featureType);
            if(featureType == 'panorama')
            {
                this.showPanoramaFeatureModal = true;
            }
            if(featureType == 'video')
            {
                this.showVideoFeatureModal = true;
            }
            if(featureType == 'audioguide')
            {
                this.showAudioFeatureModal = true;
            }
            if(featureType == 'text')
            {
                this.showTextFeatureModal = true;
            }
            if(featureType == 'augmented_reality')
            {
                this.showAugmentedRealityModal = true;
            }
            if(featureType == 'map')
            {
                this.showMapFeatureModal = true;
            }
        },
        closeCreateOneFeatureModal() {
            this.showPanoramaFeatureModal = false;
            this.showVideoFeatureModal = false;
            this.showAudioFeatureModal = false;
            this.showTextFeatureModal = false;
            this.showAugmentedRealityModal = false;
            this.showMapFeatureModal = false;
            this.featureName = '';
            this.file_types = [];
        },
        getFeatureName(featureType){
            switch (featureType) {
                case 'audioguide':
                    this.file_types = [
                        {
                            id: 2,
                            label: 'audio',
                            extension: 'MP3',
                        },
                    ]
                    return 'Audioguide';

                case 'augmented_reality':
                    return 'Augmented reality';

                case 'panorama':
                    this.file_types = [
                        {
                            id: 4,
                            label: 'panorama_image',
                            extension: 'JPG, PNG',
                        },
                        {
                            id: 5,
                            label: 'panorama_video',
                            extension: 'MP4',
                        }
                    ];
                    return 'Panorama';

                case 'quiz':
                    return 'Quiz';

                case 'text':
                    return 'Text';

                case 'video':
                    this.file_types = [
                        {
                            id: 3,
                            label: 'video',
                            extension: 'MP4',
                        },
                    ]
                    return 'Video';

                case 'map':
                    return 'Map';

              default:
                return false;
            }
        },
        showMapFeature(){
            if(this.$page.props.station.data.features.filter(el => el.type == 'map').length > 0)
            {
                return false;
            } else {
                return true;
            }
        }
    }
}
</script>
